import React from 'react';
import { Input, Checkbox } from 'antd';

const SelectValueFilter = ({
  searchTerm,
  setSearchTerm,
  filteredOptions,
  checkedList,
  setCheckedList,
}) => {
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setCheckedList(filteredOptions.map((opt) => opt.value));
    } else {
      setCheckedList([]);
    }
  };

  return (
    <>
      <Input
        placeholder="検索"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 10 }}
      />

      <Checkbox
        className="ml5"
        checked={
          filteredOptions.length > 0 &&
          checkedList.length === filteredOptions.length
        }
        indeterminate={
          checkedList.length > 0 &&
          checkedList.length < filteredOptions.length
        }
        onChange={handleSelectAllChange}
      >
        すべて選択
      </Checkbox>

      <div className="listCheckBoxTableFilter">
        <Checkbox.Group
          style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
          options={filteredOptions}
          value={checkedList}
          onChange={setCheckedList}
        />
      </div>
    </>
  );
};

export default SelectValueFilter;
